import React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Collapse } from 'reactstrap';
import { MdInfoOutline } from 'react-icons/md';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { clearBeschriftungen } from '../store/punkteMeldung/actions';
import { showConfirmDialog } from '../store/confirmDialog/actions';
import { countBeschriftungen } from '../store/punkteMeldung/commonUtils';
import { enthaeltNamen } from '../store/punkteMeldung/listenEingabe';

/**
 * Abgrenzung, nicht Fussnote: sobald zu einer EFN ein Name steht, liegen personenbezogene
 * Daten in dieser App. Der Hinweis erscheint deshalb genau dann, wenn die Spalte "Name /
 * Notiz" benutzt wird - wer ohne sie arbeitet, bekommt ihn nie zu sehen - und er laesst sich
 * nicht wegklicken, weil er die Zusage traegt, auf die sich der Veranstalter verlaesst.
 *
 * **Auch schon vor der Uebernahme**: wer eine Excel-Liste einfuegt, hat vierzig Klarnamen in
 * der App, und der Store wandert bei eingeschaltetem "Daten lokal im Browser speichern"
 * gedrosselt in den localStorage - Eingabefeld inklusive. Auf den Zeitpunkt "erste Beschriftung
 * hinterlegt" zu warten waere zu spaet.
 *
 * In der Oberflaeche heisst das "Name / Notiz", im Code "Beschriftung" - der neutrale
 * Code-Begriff sagt, was es technisch ist, die Oberflaeche sagt, wofuer es gut ist.
 *
 * **Zusammengeklappt, aber nicht wegklickbar.** Der ganze Absatz stand ueber der Teilnehmerliste
 * und nahm dort dauerhaft sieben Zeilen ein - waehrend einer Erfassung liest ihn niemand ein
 * zweites Mal. Die Zusage selbst steht deshalb weiter *immer* da, sie ist die Ueberschrift; die
 * Ausfuehrung dazu ist einen Klick entfernt. Ein Schliessknopf waere etwas anderes: das Geraet
 * am Einlass wird von mehreren bedient, und wer den Hinweis wegklickt, nimmt ihn dem naechsten.
 */
const BeschriftungenHinweis = (props) => {
	const { anzahl, eingabeHatNamen, loescheBeschriftungen } = props;
	// Bewusst nur im Bauteil und nicht im Store: aufgeklappt oder nicht ist keine Angabe, die
	// im localStorage etwas zu suchen haette.
	const [offen, setOffen] = React.useState(false);
	if(anzahl === 0 && !eingabeHatNamen) return null;
	return (
		<Alert color="info" className="py-2 mb-3">
			<div className="d-flex align-items-center gap-2">
				<MdInfoOutline fontSize="1.3em" className="flex-shrink-0" aria-hidden="true" />
				<b className="me-auto">Namen und Notizen bleiben in diesem Browser</b>
				<button type="button" className="btn btn-link btn-sm p-0 text-decoration-none text-nowrap"
					aria-expanded={offen} aria-controls="beschriftungen-hinweis-text"
					onClick={() => setOffen(!offen)}>
					{offen ? "weniger" : "was heißt das?"}
					{offen ? <IoIosArrowUp fontSize="1em" /> : <IoIosArrowDown fontSize="1em" />}
				</button>
			</div>
			<Collapse isOpen={offen}>
				<p id="beschriftungen-hinweis-text" className="small mt-2 mb-0">
					Was Sie in der Spalte <b>Name / Notiz</b> eintragen, dient ausschließlich Ihrer eigenen
					Zuordnung. Diese App <b>prüft es nicht</b> und <b>überträgt es weder an den EIV noch an
					eine Ärztekammer</b>. Gemeldet werden nur EFN, die Kennzeichen für Teilnahme und
					Lernerfolg, die Ref/Mod/WL-Punkte und das Teilnahmedatum. Gespeichert wird es nur,
					solange „Daten lokal im Browser speichern“ eingeschaltet ist – auf einem gemeinsam
					genutzten Rechner also bitte bewusst verwenden.
				</p>
			</Collapse>
			<Button color="danger" outline size="sm" className="mt-2" onClick={loescheBeschriftungen}>
				Alle Namen und Notizen löschen{anzahl > 0 && <> ({anzahl})</>}
			</Button>
		</Alert>
	);
};

const mapStateToProps = (state, ownProps) => {
	const addTeilnahme = state.punkteMeldung.addTeilnahme[ownProps.vnr];
	return {
		anzahl: countBeschriftungen(state, ownProps.vnr),
		eingabeHatNamen: Boolean(addTeilnahme) && enthaeltNamen(addTeilnahme.efn)
	};
};

const mapDispatchToProp = (dispatch, ownProps) => ({
	loescheBeschriftungen: () => dispatch(showConfirmDialog(
		"Namen und Notizen löschen",
		"Alle hinterlegten Namen und Notizen dieser Veranstaltung werden entfernt – "
		+ "auch die, die noch unübernommen im Eingabefeld stehen. Die EFNs bleiben dort erhalten. "
		+ "Die erfassten Teilnahmen und die bereits gemeldeten Punkte bleiben unverändert.",
		() => dispatch(clearBeschriftungen(ownProps.vnr)),
		"Namen und Notizen löschen"))
});

export default connect(mapStateToProps, mapDispatchToProp)(BeschriftungenHinweis);
